import { NomadicMark } from "@/components/BatchWorkbench/components/NomadicMark";
import { CREAM } from "@/components/BatchWorkbench/styles/theme";

/**
 * Full-page loading state used across auth bootstrap, route Suspense, and
 * route guards. Shows the same Nomadic mark animation as workbench reasoning
 * traces — not the old logo + teal spinner.
 *
 * `showMark` is false once the left nav is on screen. The mark is centered on
 * the viewport before that; leaving it up beside the nav makes it jump.
 */
export default function AppLoadingScreen({ showMark = true }: { showMark?: boolean }) {
  return (
    <div
      className="flex min-h-screen w-full items-center justify-center"
      style={{ background: CREAM.bg }}
      role="status"
      aria-label="Loading"
    >
      {showMark ? (
        <NomadicMark
          className="h-16 w-16"
          animate
          style={{ color: CREAM.ink }}
        />
      ) : null}
    </div>
  );
}
